import { getCoordInfo } from '@/interfaces/plan/manage';
import { Order, PlanDest } from '@/types/plan';
import * as _ from 'lodash';

export async function destGrouping(list: Order[] | PlanDest[]): Promise<PlanDest[]> {
  const retArr: PlanDest[] = [];
  if (list.length === 0) return retArr;

  list.forEach((o: Order | PlanDest) => {
    const temp: any = _.pick(o, [
      'seq',
      'name',
      'type',
      'lat',
      'lng',
      'region_group_seq',
      'region',
      'sido',
      'sigugun',
      'dongmyun',
      'ri',
      'address',
      'roadAddress',
      'jibunAddress',
      'postal_code',
      'custom_code',
      'work_time',
      'dwell_time',
      'priority',
      'memo',
      'order_count',
      'order_sheet_id',
    ]);
    retArr.push(temp);
  });

  const needCoordList = retArr.filter((item: PlanDest) => !(item.lat && item.lng && item.postal_code));
  if (needCoordList.length > 0) {
    const validList = await getCoordInfo(needCoordList);
    const checkedList: any[] = validList?.data?.data ?? [];
    checkedList.forEach((item: any) => {
      const target = retArr.findIndex((fitem) => fitem.seq === item.seq);
      if (target > -1) {
        retArr[target] = {
          ...retArr[target],
          ...item.info,
        };
      }
    });
  }

  return groupByCoord(retArr);
}

const groupByCoord = (list: PlanDest[]): PlanDest[] => {
  const retArr: PlanDest[] = [];
  const coordKeyList = _.groupBy(list, function (item) {
    return item.lat + '_' + item.lng;
  });
  let index = 1;
  _.forEach(coordKeyList, function (item, key) {
    const subTemp = _.uniqBy(item, 'name');
    _.each(subTemp, function (sItem, sindex) {
      const nameGroup = _.filter(item, ['name', sItem.name]);
      retArr.push({
        ...sItem,
        group_id: 'M_' + index + '_' + sindex,
        order_count: nameGroup.length, //_.sumBy(nameGroup, 'order_count'),
        order_info: _.map(nameGroup, 'order_sheet_id'),
      });
    });
    index++;
  });
  return retArr;
};
